(() => {
  // Minerální profil na B2B stránce: výběr složky přepíná detail. Bez JavaScriptu zůstává
  // první složka v detailu a všechny hodnoty jsou vidět v dlaždicích.
  const init = (section) => {
    if (section.dataset.b2bMineralsReady === 'true') return;
    section.dataset.b2bMineralsReady = 'true';
    const tabs = Array.from(section.querySelectorAll('[role="tab"][data-mineral-index]'));
    const tiles = Array.from(section.querySelectorAll('.b2b-minerals__tile[data-mineral-index]'));
    const detail = section.querySelector('[role="tabpanel"]');
    if (!tabs.length || !detail) return;
    const fields = {
      symbol: detail.querySelector('[data-mineral-detail-symbol]'),
      name: detail.querySelector('[data-mineral-detail-name]'),
      amount: detail.querySelector('[data-mineral-detail-amount]'),
      description: detail.querySelector('[data-mineral-detail-description]'),
    };

    const select = (index, focus) => {
      const tab = tabs[index];
      if (!tab) return;
      tabs.forEach((item, position) => {
        const active = position === index;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      tiles.forEach((tile) => tile.setAttribute('aria-pressed', String(Number(tile.dataset.mineralIndex) === index)));
      if (fields.symbol) fields.symbol.textContent = tab.dataset.mineralSymbol || '';
      if (fields.name) fields.name.textContent = tab.dataset.mineralName || '';
      if (fields.amount) fields.amount.textContent = tab.dataset.mineralAmount || '';
      if (fields.description) fields.description.textContent = tab.dataset.mineralDescription || '';
      detail.setAttribute('aria-labelledby', tab.id);
      if (focus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index, false));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        select(next, true);
      });
    });
    tiles.forEach((tile) => tile.addEventListener('click', () => select(Number(tile.dataset.mineralIndex), false)));
  };

  const initAll = () => document.querySelectorAll('[data-b2b-minerals]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Editor šablony sekci překreslí; při načtení i obnovení sekce ji inicializujeme znovu.
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-b2b-minerals]').forEach(init));
})();
